/**
 * Can be used where you want to enforce that a user should fill one of two or more fields.
 */
(function($) {

	$.fn.onefield = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.onefield.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            $this.addClass('one-field');
            $this.bind('change keyup', function(){
                var $input = $(this);
                disableFields($input, eOpts)

            });
            disableFields($this, eOpts);
        });
	};
	//
	// plugin defaults
	//
	$.fn.onefield.defaults = {
        selector: '.one-field',
        parentSelector: '.form'
    };

    function disableFields($input, eOpts) {
        if($input.val()) {
            $input.parents(eOpts['parentSelector']).find(eOpts['selector']).not($input).prop('disabled', true);
        }
        else {
            $input.parents(eOpts['parentSelector']).find(eOpts['selector']).not($input).prop('disabled', false);
        }
    }

})(jQuery);